import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createClinicalFormsApi } from "../../api-helpers/ClinicalFormsApiHelper";

interface AssessmentDate {
  lastAssessmentDate : string | undefined;
}

const initialState:AssessmentDate = {
  lastAssessmentDate : undefined
};

const lastAssessmentDateSlice = createSlice({
  name: "lastAssessmentDate",
  initialState,
  reducers: {
    setLastAssessmentDate(state, action: PayloadAction<string>) {state.lastAssessmentDate=action.payload},
    clearLastAssessmentDate(state) {
      state.lastAssessmentDate = undefined;
    },
  },
});


export const { setLastAssessmentDate, clearLastAssessmentDate } = lastAssessmentDateSlice.actions;

export default lastAssessmentDateSlice.reducer;
